<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <hm-logo/>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Forgot password V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Forgot Password? 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            Enter your email and we'll send you instructions to reset your password
          </b-card-text>

          <!-- form -->
          <b-form
            class="auth-forgot-password-form mt-2"
            @submit.prevent
          >
            <b-form-group
              label="Email"
              label-for="forgot-password-email"
            >
              <b-form-input
                id="forgot-password-email"
                v-model="email"
                placeholder="john@example.com"
                :state="!$v.email.$invalid"
              />
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
              block
              @click="forgot_password_request"
            >
              Send reset link
            </b-button>
          </b-form>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon"/>
              Back to login
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { required, email } from 'vuelidate/lib/validators'
import hmLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import api from '@/libs/axios'
import { hmError, hmSuccess } from '@/libs/toastification'

export default {
  components: {
    hmLogo
  },
  data() {
    return {
      email: null,
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg')
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    }
  },
  methods: {
    forgot_password_request() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      api.post('/web/user/forgot_password_request', { email: this.email })
        .then(r => {
          if (r.data.code === 'user_no_found') return hmError('Invalid user')
          if (r.data.code !== 'Ok') {
            return hmError('Error forgot password request')
          }
          hmSuccess('We have sent instructions to your email')
          this.$router.push({ name: 'auth-login' })
        })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
